"use strict"

jarallax(document.getElementById("top"), {
    speed: 0.2,
    // disableParallax: /iPad|iPhone|iPod|Android/,
});

// gsap.set(".tourney-details", {
//     opacity: 1
// });
// 
// var tl = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".hero",
//         start: "top 20%",
//         end: "bottom 10%",
//         scrub: true,
//         // markers: true,
//         toggleActions: "play reverse play reverse"
//     }
// });
// 
// tl
//     .to(".tourney-details, .countdown", { opacity: 1, duration: 1 })
//     .to(".tourney-details, .countdown", { opacity: 0, duration: 1 }, 0.5);

// document.addEventListener("DOMContentLoaded", function() {
//     
//     setTimeout(function() {
//         var element = document.getElementById("days");
//         var date = new Date("2025-08-07T00:00:00-07:00")
//         var countDownDate = date.getTime();
//         var now = new Date().getTime();
//         var tz = new Date().getTimezoneOffset();
//         // var now = dateNow.getTime();
//         var timeLeft = countDownDate - (now - tz);
//         var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24)); console.log('days', days, 'now', now, 'tz', tz);
//         
//         document.getElementById("days").innerHTML = days;
//         
//         // element.counterAlreadyFired = false;
//         if (days > 1) {
//             element.counterSpeed = 2000 / 45;
//             element.counterTarget = +days;
//             element.counterCount = 0;
//             element.counterStep = element.counterTarget / element.counterSpeed;
//             
//             element.updateCounter = function() {
//                 element.counterCount = element.counterCount + element.counterStep;
//                 element.innerHTML = Math.ceil(element.counterCount);
//                 
//                 if (element.counterCount < element.counterTarget) {
//                     setTimeout(element.updateCounter, element.counterSpeed);
//                 } else {
//                     element.innerText = element.counterTarget;
//                 }
//             }
//         
//             var isElementVisible = function isElementVisible(el) {
//                 var scroll = window.scrollY || window.pageYOffset;
//                 var boundsTop = el.getBoundingClientRect().top + scroll;
//                 var viewport = {
//                     top: scroll,
//                     bottom: scroll + window.innerHeight
//                 }
//                 var bounds = {
//                     top: boundsTop,
//                     bottom: boundsTop + el.clientHeight
//                 }
//                 return (
//                     (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
//                     (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
//                 );
//             }
//         
//             var handleScroll = function handleScroll() {
//                 if (true === element.counterAlreadyFired) return;
//                 if (!isElementVisible(element)) return;
//                 element.updateCounter();
//                 element.counterAlreadyFired = true;
//             }
//         }
//         
//         window.addEventListener("scroll", handleScroll);
//         window.addEventListener("load", handleScroll);
//         
//         if (days == 1) {
//             jQuery('.countdown--label').html('Day to go');
//         }
//     }, 3000);
// });